import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { updateUserPreferences } from "../../api/usersApi";
import { t } from "i18next";

interface LanguageDropdownProps {
  onLanguageSelect?: () => void; // Optional prop
}

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  onLanguageSelect,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const handleLanguageChange = async (language_code: string) => {
    await i18n.changeLanguage(language_code);
    setCurrentLanguage(language_code);
    localStorage.setItem("language", language_code);
    const userPreferences: any = {
      language_code: language_code,
    };
    await updateUserPreferences(userPreferences);
    setIsOpen(false);
  };

  const toggleDropdown = () => setIsOpen(!isOpen);
  const languageName = new Intl.DisplayNames([i18n.language], {
    type: "language",
  });
  const languageCodes = ["de", "en", "es", "fr"];

  const sortedLanguages = languageCodes.sort((a, b) => {
    if (a === i18n.language) {
      return -1;
    }
    return (languageName.of(a) ?? a).localeCompare(languageName.of(b) ?? b);
  });

  return (
    <div className="relative z-10">
      {/* Trigger inherits its text color from the host (menuItem in the
          header menu) so it stays readable in both themes. */}
      <button className="w-full rounded text-left" onClick={toggleDropdown}>
        <span>{t("Language")}</span>
      </button>
      {isOpen && (
        <ul
          className="absolute left-0 top-full z-40 mt-1 w-36 overflow-hidden rounded-xl border border-off-white-dark bg-white text-primary-off-black shadow-lg transition duration-300 dark:border-storm-blue-border dark:bg-storm-blue-card dark:text-primary-off-white"
          onClick={onLanguageSelect}
        >
          {sortedLanguages.map((code) => {
            const languageLabel = languageName
              .of(code)
              ?.slice(0, 1)
              .toUpperCase()
              .concat(languageName.of(code)?.slice(1) ?? "");
            return (
              <li
                className="min-w-24 hover:bg-sky-blue-light/30 dark:hover:bg-white/10"
                key={code}
              >
                <button
                  className="py-2 whitespace-no-wrap w-full"
                  onClick={() => handleLanguageChange(code)}
                >
                  {code === currentLanguage ? (
                    <strong>{languageLabel}</strong>
                  ) : (
                    languageLabel
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default LanguageDropdown;
